import { PublicClientApplication } from "@azure/msal-browser";

export const MSAL_REDIRECT_URI = `${window.location.origin}/login`;

type MsalClient = { instance: PublicClientApplication, ready: Promise<void> };

let client: (MsalClient & { key: string }) | null = null;

export const getMsalClient = (clientId: string, authority: string): MsalClient => {
  const key = `${clientId} ${authority}`;
  if (client?.key !== key) {
    const instance = new PublicClientApplication({
      auth: {
        clientId,
        authority,
        redirectUri: MSAL_REDIRECT_URI,
      },
      cache: {
        cacheLocation: "sessionStorage",
      },
    });
    client = { key, instance, ready: instance.initialize() };
  }

  return client;
};

